import React from "react"
import {
	TableHead,
	Table,
	TableContainer,
	TableRow,
	TableCell,
	TableBody
} from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import { FormattedInteractionsDataResponse } from "@/pages/Admin/TrackableLinks/TrackableLinkMetricsV2/TrackableLinkInteractions"
import { TableColumn } from "@/components/DataTable"

type TrackableLinkInteractionsSkeletonProps = {
	columnList: TableColumn<FormattedInteractionsDataResponse>[]
}

const TrackableLinkInteractionsSkeleton: React.FC<TrackableLinkInteractionsSkeletonProps> = (props) => {
	const { columnList } = props

	return (
		<TableContainer>
			<Table stickyHeader size="small">
				<TableHead>
					<TableRow>
						{columnList.map((item) => (
							<TableCell key={item.field} align="left">
								{item.label}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{Array.from({ length: 10 }, (_, index) => (
						<TableRow key={index}>
							<TableCell key={index} align="left">
								<Skeleton variant="rect" width={40} height={15} style={{ borderRadius: 4 }} />
							</TableCell>
							<TableCell key={index} align="left">
								<Skeleton variant="rect" width={170} height={15} style={{ borderRadius: 4 }} />
							</TableCell>
							<TableCell key={index} align="left">
								<Skeleton variant="rect" width={120} height={15} style={{ borderRadius: 4 }} />
							</TableCell>
							<TableCell key={index} align="left">
								<Skeleton variant="rect" width={130} height={15} style={{ borderRadius: 4 }} />
							</TableCell>
							<TableCell key={index} align="left">
								<Skeleton variant="rect" width={130} height={15} style={{ borderRadius: 4 }} />
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

export default TrackableLinkInteractionsSkeleton
